import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Card } from "react-bootstrap";
import Layout from "../Components/Layout/Layout";
import {
  collectiondetailsAction,
  saveCollectionToSelf,
} from "../Redux/Action/CollectionAction";
import { useDispatch, useSelector } from "react-redux";
import LoaderComponent from "../Components/common/LoaderComponent";
import { Decryptedid, Encryptedid } from "../Util/BcruptEncyptid";
import { truncateTextbrowse } from "../Util/HelperFunction";
import { activityListAction } from "../Redux/Action/AuthAction";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TfiAlert } from "react-icons/tfi";
import { groupData } from "../Constant/ConstantData";

export default function SharedCollection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, type } = useParams();
  const [idval, setIdval] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const safeDecrypt = () => {
      try {
        const decoded = atob(id);
        const decrypted = Decryptedid(decoded);
        return decrypted && decrypted.trim() ? decrypted.trim() : id;
      } catch (error) {
        console.error("Decryption failed:", error);
        return id;
      }
    };

    setIdval(safeDecrypt());
  }, [id]);
  const collectiondetails = useSelector(
    (state) => state?.collectionSlice?.collectionDetails
  );

  useEffect(() => {
    if (!idval) return;
    setIsLoading(true);
    const fetchCollectionDetails = () =>
      dispatch(collectiondetailsAction(idval));
    const fetchActivityData = () =>
      dispatch(activityListAction({ id: collectiondetails?._id }));
    Promise.all([fetchActivityData(), fetchCollectionDetails()]).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch, idval, collectiondetails?._id]);

  useEffect(() => {
    if (type === "student") {
      window.location.href = `https://apps.apple.com/in/app/peerscroller/${idval}`;
    }
  }, [type, idval]);

  const gotoPlayback = (collectionId, videoId) => {
    navigate(`/collection-shorts/${Encryptedid(collectionId)}/${videoId}`);
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSaveCollection = () => {
    setIsSaving(true);
    dispatch(saveCollectionToSelf({ collectionId: idval }))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          navigate(`/collection-detail/${Encryptedid(idval)}`);
        }
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const renderTooltip = (res) => (props) =>
    (
      <Tooltip id="custom-tooltip" {...props} className="custom-tooltip">
        <h4 className="contains-head">Contains sensitive content:</h4>
        <p className="conatin-desc m-0 ">{res?.sensitiveType}</p>
        <div className="tooltip-arrow-custom" />
      </Tooltip>
    );

  return (
    <Layout>
      <>
        <Container fluid className="px-4">
          
          <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className="p-0 me-3 text-decoration-none"
                onClick={() => navigate(-1)}
                style={{ color: "#6c757d" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
              </Button>
              <div>
                <p className="text-muted mb-1 small">
                  Collections / {collectiondetails?.name}
                </p>
                <h2 className="mb-0 fw-bold" style={{ color: "#2c3e50" }}>
                  {collectiondetails?.name}
                </h2>
              </div>
            </div>
            {collectiondetails?.video?.length > 0 && (
              <Button
                variant="primary"
                onClick={handleSaveCollection}
                className="d-flex align-items-center gap-2 px-4 py-2"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: "12px",
                  fontWeight: "500",
                }}
                disabled={isSaving}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                  <polyline points="17,21 17,13 7,13 7,21" />
                  <polyline points="7,3 7,8 15,8" />
                </svg>
                {isSaving ? "Saving...." : "Save Collection"}
              </Button>
            )}
          </div>

          
          <div className="py-4">
            {isLoading ? (
              <LoaderComponent />
            ) : (
              <>
                {Array.isArray(collectiondetails?.video) &&
                collectiondetails?.video?.length > 0 ? (
                  <>
                    <div className="mb-4">
                      <h5 className="text-muted mb-3">
                        {collectiondetails?.video?.length} Videos in Collection
                      </h5>
                    </div>
                    <Row className="g-4">
                      {collectiondetails?.video?.map((video, index) => (
                        <Col key={video._id} xxl={2} xl={3} lg={4} md={6} sm={6} xs={12}>
                          <div
                            className="video-card"
                            onClick={() => gotoPlayback(collectiondetails?._id, video?._id)}
                          >
                            
                            <div className="video-thumbnail">
                              <img
                                src={video.cover_url}
                                alt={video.title}
                                className="img-fluid"
                              />
                              <span className="duration-badge">
                                {video.video_duration}
                              </span>
                              
                              <span
                                className="position-absolute text-white"
                                style={{
                                  top: "12px",
                                  right: "12px",
                                  backgroundColor: "rgba(0,0,0,0.7)",
                                  borderRadius: "12px",
                                  padding: "4px 10px",
                                  fontSize: "0.75rem",
                                  fontWeight: "600",
                                }}
                              >
                                #{index + 1}
                              </span>
                            </div>

                            
                            <div className="video-content">
                              <h3 className="video-title">{video.title}</h3>

                              <p className="video-description">
                                {video.description
                                  ? truncateTextbrowse(video.description, 25)
                                  : ""}
                              </p>

                              <div className="video-footer d-flex align-items-start gap-2">
                                {video.isSensitive && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={renderTooltip(video)}
                                  >
                                    <span className="alert-icon">
                                      <TfiAlert size={16} />
                                    </span>
                                  </OverlayTrigger>
                                )}

                                <div className="group-tags d-flex flex-wrap gap-2 mt-2">
                                  {video.group?.map((gid) => {
                                    const name = groupData.find(
                                      (g) => g.id === gid
                                    )?.name;

                                    return (
                                      name && (
                                        <span key={gid} className="group-tag">
                                          {name}
                                        </span>
                                      )
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </>
                ) : (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center"
                    style={{ minHeight: "400px" }}
                  >
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ccc"
                      strokeWidth="1"
                      className="mb-3"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <h5 className="text-muted mb-2">No Videos Found</h5>
                    <p className="text-muted">
                      This collection doesn't contain any videos yet.
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </Container>
      </>
    </Layout>
  );
}
